import React from 'react'
import PropTypes from 'prop-types'
import { IonContent, IonPage } from '@ionic/react'
import { Header, BackToSearchButton } from 'components'
import searchBackdropImg from 'images/search-backdrop.png'

const propTypes = {
  children: PropTypes.node.isRequired,
  hideBackButton: PropTypes.bool,
  showBackdrop: PropTypes.bool,
}

function Layout({ children, hideBackButton = false, showBackdrop = false }) {
  const searchBackdrop = (
    <div className="search-img-container">
      <img alt="TSS" src={searchBackdropImg} className="background-img" />
    </div>
  )

  return (
    <IonPage>
      <Header />
      {!hideBackButton && <BackToSearchButton />}
      <IonContent>
        {showBackdrop && searchBackdrop}
        <div className="content-container">
          <div className="content-container-internal">{children}</div>
        </div>
      </IonContent>
    </IonPage>
  )
}

Layout.propTypes = propTypes

export default Layout
